type Listener = (token: string | null) => void;

let token: string | null = null;
const listeners = new Set<Listener>();

export const csrfStore = {
  get(): string | null {
    return token;
  },
  set(next: string | null): void {
    if (token === next) return;
    token = next;
    listeners.forEach((fn) => fn(token));
  },
  clear(): void {
    csrfStore.set(null);
  },
  subscribe(fn: Listener): () => void {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  },
};
